// src/pages/Onboarding.jsx

import React, { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth, db } from '../config/firebaseConfig';
import { AuthContext } from '../context/AuthContext';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import OnboardingForm from '../components/OnboardingForm';
import StepIndicator from '../components/StepIndicator';
import LanguageSelector from '../components/LanguageSelector';

const Onboarding = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const intl = useIntl();
  const [currentStep, setCurrentStep] = useState(1);
  const [onboardingComplete, setOnboardingComplete] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/get-started');
    }
  }, [user, navigate]);

  useEffect(() => {
    const redirectNextStep = async () => {
      if (!user?.uid || !onboardingComplete) return;

      const userRef = doc(db, 'users', user.uid);
      const settingsRef = doc(db, 'users', user.uid, 'settings', 'main');

      const [userSnap, settingsSnap] = await Promise.all([
        getDoc(userRef),
        getDoc(settingsRef),
      ]);

      const userData = userSnap.data();
      const settingsData = settingsSnap.exists() ? settingsSnap.data() : {};

      if (!userData?.subscription?.plan) {
        navigate('/dashboard/subscription?lang=pt');
        return;
      }

      if (!settingsData?.assistantName || !settingsData?.greeting || !settingsData?.defaultLanguage) {
        navigate('/dashboard/chatbot-settings?lang=pt');
        return;
      }

      if (!userData?.whatsapp) {
        navigate('/dashboard/profile-users?lang=pt');
        return;
      }

      const propsSnap = await getDocs(collection(db, `users/${user.uid}/properties`));
      if (propsSnap.empty) {
        navigate('/dashboard/properties?lang=pt');
        return;
      }

      navigate('/dashboard?lang=pt');
    };

    redirectNextStep();
  }, [user, onboardingComplete, navigate]);

  const handleLogout = () => {
    signOut(auth).then(() => {
      navigate('/login');
    });
  };

  return (
    <div className="fullscreen-layout">
      <div className="auth-header">
        <span className="user-email">{user?.email}</span>
        <span className="logout-link" onClick={handleLogout}>
          {intl.formatMessage({ id: 'logout' })}
        </span>
      </div>

      <div className="onboarding-step">
        <StepIndicator step={currentStep} />
        <OnboardingForm
          user={user}
          onComplete={() => navigate('/dashboard')}
          setCurrentStep={setCurrentStep}
        />
      </div>

      <footer className="auth-footer">
      <div className="left"><p>{intl.formatMessage({ id: 'footer.rights' })}</p></div>
      <div className="right">
        <div className="footer-language-selector">
          <LanguageSelector />
        </div>
      </div>
    </footer>
    
    </div>
  );
};

export default Onboarding;

